import { resolve } from "ui-common/di";
import type { IAuthState } from "ui-common/services/auth/types";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const profileDataQueryKey = "profileData";

export const profileDataQueryOptions = queryOptions({
  queryKey: [profileDataQueryKey],
  queryFn: async () => {
    const authState = resolve<IAuthState>("authState");
    await authState.ready;
    if (!authState.isAuthenticated.get()) return null;
    return rpc(profileDataQueryKey, undefined);
  },
});
